var hamburgerIcon = "<svg class=\"icon-humburger\" xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"24\" viewBox=\"0 0 30 20\">\n  <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#B4975A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\">\n    <path d=\"M29 10H1M29 1H1M29 19H1.278\"></path>\n  </g>\n</svg>";

export { hamburgerIcon as default };
